import { Link } from 'react-router-dom'

const Footer = () => (
  <footer>
    <p>© 2021 Metis Analytics. All rights reserved.</p>
    <ul>
      <a target='_blank' href='mailto:team@metisanalytics.co'>Contact</a>
      <Link to='/privacy'>Privacy Policy</Link>
      <Link to='/terms'>Terms & Conditions</Link>
    </ul>
  </footer>
)

export default Footer
